import { toast } from "sonner";
import { invokeProtectedFunction } from "@/lib/invokeProtectedFunction";
import { BUY_TOKENS_URL } from "@/components/landing/homepage-data";
import { closeCheckoutTab, navigateCheckoutTab, openCheckoutTab } from "@/lib/billing/checkoutTab";
import { checkoutAttribution, readFirstTouch } from "@/lib/tracking/firstTouch";

/**
 * In-app token-pack checkout: asks the server to build a Shopify cart for a
 * one-time token pack and redirects there. Mirrors startSubscriptionCheckout.
 * `email` (the signed-in user's account email) is forwarded so the purchase
 * auto-links to their account.
 */
export async function startTokenCheckout(
  variantId: string,
  email?: string,
  countryCode?: string,
): Promise<boolean> {
  const checkoutTab = openCheckoutTab();
  try {
    const { data, error } = await invokeProtectedFunction<{ ok?: boolean; checkoutUrl?: string }>(
      "create-token-checkout",
      { body: { variantId, email, countryCode, attribution: checkoutAttribution(readFirstTouch()) } },
    );
    if (error) throw error;
    if (!data?.ok || !data.checkoutUrl) {
      throw new Error("No checkout URL returned.");
    }
    navigateCheckoutTab(checkoutTab, data.checkoutUrl);
    return true;
  } catch (err) {
    closeCheckoutTab(checkoutTab);
    console.error("[token-checkout] failed to start:", err);
    toast.error("We couldn't start checkout. Please try again — or buy on our store page.", {
      action: {
        label: "Store page",
        onClick: () => window.open(BUY_TOKENS_URL, "_blank", "noopener,noreferrer"),
      },
    });
    return false;
  }
}
